import { getAttachmentsForInspection } from "../../services/attachmentService";
import { setAttachments, setError, setLoading } from "../slices/attachmentSlice";
import { AppThunk } from "../store";

export const fetchAttachments = (inspectionId: string): AppThunk => async (dispatch, getState) => {
    // Check if we already have attachments for this inspection
    const currentInspectionId = getState().attachment.currentInspectionId;
    if (currentInspectionId === inspectionId) {
        return;
    }

    dispatch(setLoading(true));
    dispatch(setError(false));

    try {
        const attachments = await getAttachmentsForInspection(inspectionId);
        dispatch(setAttachments({ inspectionId, attachments }));
    } catch {
        dispatch(setError(true));
    } finally {
        dispatch(setLoading(false));
    }
};
